import { render, staticRenderFns } from "./right.vue?vue&type=template&id=eb30de58&scoped=true"
import script from "./right.vue?vue&type=script&lang=js"
export * from "./right.vue?vue&type=script&lang=js"
import style0 from "./right.vue?vue&type=style&index=0&id=eb30de58&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb30de58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb30de58')) {
      api.createRecord('eb30de58', component.options)
    } else {
      api.reload('eb30de58', component.options)
    }
    module.hot.accept("./right.vue?vue&type=template&id=eb30de58&scoped=true", function () {
      api.rerender('eb30de58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/layout/right.vue"
export default component.exports